import { ConsoleLogger, fetchAuthSession } from "@aws-amplify/core";
import {
  ChimeSDKMessagingClient,
  ListChannelMembershipsForAppInstanceUserCommand,
  ListChannelMessagesCommand,
  SendChannelMessageCommand,
  UpdateChannelReadMarkerCommand,
} from "@aws-sdk/client-chime-sdk-messaging";
import { DefaultMessagingSession } from "amazon-chime-sdk-js";
import { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../hooks";

class MessagingManager {
  constructor(credentials) {
    this.client = new ChimeSDKMessagingClient({
      region: "us-east-1",
      credentials,
    });

    this._logger = new ConsoleLogger(`Teleassistance-${crypto.randomUUID()}`);
    this.messagingSession = null;
  }

  join(messagingSessionConfiguration) {
    this.messagingSession = new DefaultMessagingSession(
      messagingSessionConfiguration,
      this._logger,
    );
  }

  leave() {
    this.messagingSession?.stop();
    this.messagingSession = null;
  }

  async listChannelMessages(payload) {
    const listChannelMessagesCommand = new ListChannelMessagesCommand(payload);

    return this.client?.send(listChannelMessagesCommand);
  }

  async getReadMarkerTimestamp(payload) {
    const listChannelMembershipsForAppInstanceUserCommand =
      new ListChannelMembershipsForAppInstanceUserCommand(payload);

    return this.client?.send(listChannelMembershipsForAppInstanceUserCommand);
  }

  async updateReadMarkerTimestamp(payload) {
    const updateChannelReadMarkerCommand = new UpdateChannelReadMarkerCommand(
      payload,
    );

    return this.client?.send(updateChannelReadMarkerCommand);
  }

  async sendChannelMessage(payload) {
    const sendChannelMessageCommand = new SendChannelMessageCommand(payload);

    return this.client?.send(sendChannelMessageCommand);
  }

  start() {
    this.messagingSession?.start();
  }
}

const useMessagingManager = () => {
  const { user } = useAuth()
  const [temporaryCredentials, setTemporaryCredentials] = useState({})

  useEffect(() => {
    const loadTemporaryCredentials = async () => {
      const user = await fetchAuthSession()

      setTemporaryCredentials(user?.credentials)
    }
    if (user) {
      loadTemporaryCredentials()
    }
  }, [user])

  const messagingManager = useMemo(
    () =>
      new MessagingManager(temporaryCredentials),
  [temporaryCredentials]);

  return messagingManager;
};

export default useMessagingManager;
